import './ErrorPage.css';

const ErrorPage = ({error}) => {
	return (
		<div className='error-page'>
			{
				error.response.status === 409 ? (
					<h1>{error.response.data.error}</h1>
				) : (
					<h1>{error.message}</h1>
				)
			}
		</div>
	);
}
 
export default ErrorPage;